import { useEffect, useState } from "react";
import "./style.css";
import { useAuth } from "../../context/AuthContext";
import api from "../../services/axios";
import { Link } from "react-router-dom";
import Avatar from "../NumberOptions/Avatar";

export default function RecentCustomers() {
  const [recent_Tickets, setRecent_Tickets] = useState([]); 
  const { authUser } = useAuth();
  
  useEffect(() => {
    const loadRecent = async () => {
      try {
        const response = await api.post("/recent_tickets", {
          isAdmin: authUser.isAdmin,
          Code: authUser.Code,
          Agents_Company: authUser.Agents_Company,
        });
        setRecent_Tickets(response.data.data || []);
      } catch (error) {
        console.error("Failed to load recent tickets", error);
      }
    };

    loadRecent();
  }, []);



  return (
    <div className="rcentcustomers">
      <div className="customers-header">
        <h1><strong>Recent Customers</strong></h1>
        <span>List of Customer with Top Assists</span>
      </div>

      <div className="customerbox-main d-flex flex-column">
        {recent_Tickets.length === 0 && <p>No recent tickets found.</p>}

        {recent_Tickets.map((ticket, index) => (
          <div
            className="customerbox d-flex align-items-center justify-content-between"
            key={index}
          >
            <div className="customerboxleft d-flex align-items-center">
        
              <Avatar name={ticket.Customer_Name} index={index} width={36} height={36} fontSize={14}/>
              <figure className="nameemail">
                <figcaption>{ticket.Customer_Name ||''}</figcaption>
                <Link to={`/view-ticket-history/${ticket.Ticket_No}`}>Ticket #: {ticket.Ticket_No}</Link>
              </figure>
            </div>

            <div className="customerboxright d-flex flex-column text-center">
              <strong className={`statusbtn ${ticket.Status_Name?.toLowerCase().replace(/\s+/g, '-')}`}>{ticket.Status_DisplayName}</strong>
              {/* <span>{ticket.City || "N/A"}</span> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
